import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { SimpleProgressComponent } from '../simpleprogress.component';
import { DialogTitleComponent } from '../dialog-title/dialog-title.component';
import { MaterialModule } from '../../material.module';

@Component({
    selector: 'app-update-notification-dialog',
    templateUrl: './update-notification-dialog.component.html',
    imports: [MaterialModule, DialogTitleComponent, SimpleProgressComponent]
})
export class UpdateNotificationDialogComponent implements OnInit {

  startPageUrl: SafeResourceUrl;
  reloading = false;

  private dialogRef = inject(MatDialogRef<UpdateNotificationDialogComponent>);
  private sanitizer = inject(DomSanitizer);

  constructor() {
    if (this.dialogRef) {
      this.dialogRef?.keydownEvents().subscribe(event => {
        if (event.key === "Escape") {
          this.dialogRef.close();
        }
      });
    }
  }

  ngOnInit() {
    this.startPageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.helpUrl + '/releases');
  }

  async reload(ev: Event): Promise<boolean> {
    this.reloading = true;
    ev.stopPropagation();
    ev.preventDefault();
    setTimeout(() => window.location.reload());
    return false;
  }
}
